import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import ViewStreamIcon from '@mui/icons-material/ViewStream';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';

export type CardLayout = 'row' | 'column';

/** Row / column switch for the Main tab's entity cards. */
export function CardLayoutToggle({ value, onChange }: { value: CardLayout; onChange: (layout: CardLayout) => void }) {
  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      size="small"
      onChange={(_, val) => {
        if (val) onChange(val);
      }}
      sx={{
        backgroundColor: 'var(--color-bg)',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 'var(--radius-md)',
        p: 0.4,
        gap: 0.4,
        '& .MuiToggleButton-root': { border: 'none', borderRadius: '8px !important', px: 1 },
        '& .Mui-selected': {
          backgroundColor: 'var(--color-primary) !important',
          color: '#fff !important',
        },
      }}
    >
      <Tooltip title="Row layout">
        <ToggleButton value="row" sx={{ px: 1 }}>
          <ViewStreamIcon fontSize="small" />
        </ToggleButton>
      </Tooltip>
      <Tooltip title="Column layout">
        <ToggleButton value="column" sx={{ px: 1 }}>
          <ViewColumnIcon fontSize="small" />
        </ToggleButton>
      </Tooltip>
    </ToggleButtonGroup>
  );
}
